import { render } from "./LoginDialog.vue?vue&type=template&id=5d38ba93&ts=true"
import script from "./LoginDialog.ts?vue&type=script&lang=ts&external"
export * from "./LoginDialog.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__